import { Injectable } from '@angular/core'
import { ApiService } from './api.service'
import { config } from '../config/config'

import { UserForm } from '../models/user-form.model'
import { User } from '../models/user.model'

@Injectable()
export class UsersService {
  public currentUser = new User()

  constructor (private api: ApiService) {}

  async get (search: string = null, enableBeforeAfter = true): Promise<User[]> {
    let query = `${config.api.url}/api/users`
    if (search) query += `?search=${search}`

    const data = await this.api.get(query, null, {enableBeforeAfter})
    return data.map(el => new User().cast(el))
  }

  async getById (id): Promise<User> {
    const data = await this.api.get(`${config.api.url}/api/users/${id}`)
    return new User().cast(data)
  }

  getTrees (id = null) {
    let query = `${config.api.url}/api/users/trees`
    if (id) query += `/${id}`

    return this.api.get(query)
  }

  async put (form: UserForm): Promise<User> {
    const data = await this.api.put(`${config.api.url}/api/users/${form.id}`, form)
    return new User().cast(data)
  }

  async post (form: UserForm): Promise<User> {
    const data = await this.api.post(`${config.api.url}/api/users`, form)
    return new User().cast(data)
  }

  delete (id: string): Promise<Object> {
    return this.api.delete(`${config.api.url}/api/users/${id}`)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/services/users.service.ts